import { render, staticRenderFns } from "./IndagineEpidemiologicaEpatitiViewComponent.vue?vue&type=template&id=0512350a"
import script from "./IndagineEpidemiologicaEpatitiViewComponent.vue?vue&type=script&lang=js"
export * from "./IndagineEpidemiologicaEpatitiViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports